import { API_BASE_URL, ENDPOINTS } from '@/api/endpoints.js';

// Enregistre la zone hors quiz (ex: overlay sur l'écran de résultat). Auth via cookie.
export const recordZone = async (zone, contestId) => {
    const res = await fetch(`${API_BASE_URL}${ENDPOINTS.PROFILING.RECORD_ZONE}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ zone, contestId }),
    });
    if (!res.ok) {
        const body = await res.text();
        let message;
        try { message = JSON.parse(body).message; } catch { message = body; }
        throw new Error(message || `Erreur API ${res.status}`);
    }
};
